module.exports = __webpack_public_path__ + "img/nodejs.1abbc8aa.svg";